import { useQuery } from "@tanstack/react-query";
import { apiConfig } from "../../config";
import ApiFilters from "./api-filters";
import { IGetFiltersParams } from "./interfaces/IGetFilters";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";

export const useFilters = () => new ApiFilters(apiConfig());
export const useGetFiltersQuery = (params: IGetFiltersParams) => {
  const filters = useFilters();
  return useQuery(
    [...getKey(Keys.getFilters), ...Object.values(params ?? {})],
    () => filters.getFilters({ ...params }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );
};
